/**
 * Form validation
 *
 * @since 1.0.0
 */
import hyperform from 'hyperform'

const FormValidation = () => {
  const forms = document.querySelectorAll('.js-form')
  if (forms.length < 1) return

  ;[...forms].forEach(form => {

    hyperform(form)
    const inputs = form.querySelectorAll('input,textarea,select')

    ;[...inputs].forEach(input => {

      // All required inputs
      if (input.required) {
        input.addEventListener('invalid', e => e.preventDefault())
      }

      // All required file-uploaders
      if (input.required && input.classList.contains('js-upload-input')) {
        input.addEventListener('invalid', e => {
          input.closest('.js-upload-button').classList.add('is-invalid')
        })
        input.addEventListener('valid', e => {
          input.closest('.js-upload-button').classList.remove('is-invalid')
        })
      }

    })

    // Register a custom validator for sum
    const sum = form.querySelector('input[name="sum"]')

    if (sum) {
      hyperform.addValidator( form.querySelector('input[name="sum"]'), (element) => {
        const nr_1 = form.querySelector('input[name="nr_1"]')
        const nr_2 = form.querySelector('input[name="nr_2"]')
        const answer = parseInt(nr_1.value) + parseInt(nr_2.value)
    
        let valid = parseInt(element.value) === answer
        element.setCustomValidity( valid ? '' : 'Wrong answer' )
    
        return valid
      })
    }
    // End sum

  }) // End forEach
}

export default FormValidation


// import hyperform from 'hyperform'
// const FormValidation = () => {
//   hyperform(window)
// }
// export default FormValidation


// WEBPACK FOOTER //
// ./src/js/modules/FormValidation.js